import { createModuleApi } from '@wit-support/admin-client-core';
const api = createModuleApi({ errorFormat: 'raw' });
export function setPaymentApiBaseUrl(url) {
    api.setBaseUrl(url);
}
/**
 * Payment request log, newest-first, keyset-paged. Pass `cursor` (an opaque
 * value from a prior page's `nextCursor`) to fetch the next page, and `limit`
 * to size the page (server default 50, max 200). Optionally scope to a target.
 */
export async function listPaymentRequests(opts) {
    const params = new URLSearchParams();
    if (opts?.targetId)
        params.set('targetId', opts.targetId);
    if (opts?.cursor)
        params.set('cursor', opts.cursor);
    if (opts?.limit !== undefined)
        params.set('limit', String(opts.limit));
    const qs = params.toString();
    return api.get(`/api/payment/requests${qs ? `?${qs}` : ''}`);
}
/**
 * Run one payment operation through the SAME logged port the rail uses — so the
 * test is logged identically and exercises the exact same adapter/error path as
 * production. Always 200; outcomes (not configured / resolved / error) are
 * encoded in the body. Cancel operations are REAL cancels.
 */
export async function runPaymentTest(req) {
    return api.post('/api/payment/test', req);
}
//# sourceMappingURL=api.js.map